import {
  ContentPostData_MeetUs,
  ContentPost,
  ContentPostStatus
} from 'portals/types';

export const prepareMeetUsPageData = (
  content: ContentPost<ContentPostData_MeetUs>[]
) => {
  const data = content
    .map(event => ({
      ...event,
      data: {
        ...event.data,
        startDate: new Date(event.data.startDate),
        endDate: new Date(event.data.endDate)
      }
    }))
    .filter(event => event.status === ContentPostStatus.PUBLISHED);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const sortedEvents = data.sort(
    (a, b) => b.data.endDate.getTime() - a.data.endDate.getTime()
  );

  const currentEvent =
    sortedEvents.find(
      event => event.data.startDate <= today && today <= event.data.endDate
    ) ?? sortedEvents[0];

  const pastEvents = sortedEvents
    .filter(event => event.key !== currentEvent.key)
    .filter(event => event.data.startDate <= new Date()); // Only include past events

  return {
    pastEvents: pastEvents.map(e => formatEvent(e)),
    currentEvent: formatEvent(currentEvent)
  };
};

const formatDate = (date: Date | undefined) =>
  date ? date.toLocaleDateString('en-GB') : '';

const formatEvent = (
  event: ContentPost<
    Omit<ContentPostData_MeetUs, 'startDate' | 'endDate'> & {
      startDate: Date;
      endDate?: Date;
    }
  >
) => ({
  ...event,
  data: {
    ...event.data,
    startDate: formatDate(event.data.startDate),
    endDate: formatDate(event.data.endDate)
  }
});
